//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio/Nicolas Pascucci
// Creation Date : 25/05/2024
// Version : 1
// Description : es la pantalla para ver el checklist despues de que lo
// completaron - cuando ponen -presione aqui para ver el check
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  Paper,
  TableRow,
  TableCell,
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Divider from "@mui/material/Divider";
//ADJUNTAR
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR IMAGEN
import FileUploadCheck from "./FileUploadCheck";
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR IMAGEN
import moment from "moment";
// imprimir
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

function VerResultadoCheck(props) {
  const {
    responsable,
    sucursal,
    fecha,
    mostrarResultadoCheck,
    tabla,
    estados,
  } = props;

  //console.log("ESTADO COMPLETO",estados);
  // console.log("ESTADOS",estados[0].auditado,estados[0].auditor,estados[0].fecha_auditado);

  const fechaFormat = moment(fecha).format("YYYY-MM");
  const [resultadosCheck, setResultadosCheck] = useState();
  const [selectedDate, setSelectedDate] = useState("");
  const [depositoSeleccionado, setDepositoSeleccionado] = useState("");
  const [uuid, setUuid] = useState(uuidv4()); //ADJUNTAR IMAGEN
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR IMAGEN
  const [checkboxStates, setCheckboxStates] = useState({});
  const [observaciones, setObservaciones] = useState({});
  const [fechaResultadoCheck, setFechaResultadoCheck] = useState({});
  const [diasHabiles, setDiasHabiles] = useState({});
  // imprimir
  // -----------------------------------------------

  const estilosImpresion = `
  @media print {
    .MuiTextField-root {
      width: 100% !important;
    }
    .MuiBox-root {
      background-color: white !important;
    }
  }
      @media print {
    .nombre-item {
      font-size: 16px !important;
    }
    .definicion-item {
      font-size: 14px !important;
     }
    .titulo-grupo {
      text-align: center !important;
    }
  }
`;

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({
    content: () => contentRef.current,
    pageStyle: estilosImpresion,
  });
  // -----------------------------------------------

  // -------- fecha -----------//
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };
  const formattedDate = `${selectedDate}`;
  // ----------------------------- GET ---------------------- //
  const [gruposEItems, setGruposEItems] = useState([]);
  const [terminado, setTerminado] = useState(false);

  const obtenerGruposEItems = () => {
    fetch(UrlApi + "/checklist_rrhh_grupos/activos")
      .then((response) => response.json())
      .then((grupos) => {
        const promises = grupos.map((grupo) => {
          // Retorna una promesa para cada llamada a la API
          return fetch(
            UrlApi +
              `/checklist_rrhh_grupos/itemxgrupoActivos/${grupo.id_grupo}`
          )
            .then((response) => response.json())
            .then((items) => ({ grupo, items }));
        });
        // Espera a que todas las promesas se resuelvan
        return Promise.all(promises);
      })
      .then((gruposItemsArray) => {
        // Una vez que todas las llamadas a la API se completen con éxito,
        // actualiza el estado con el array completo de grupos e items
        setGruposEItems(gruposItemsArray);
        setTerminado(true);
      })
      .catch((error) =>
        console.error("Error al obtener grupos e items:", error)
      );
  };

  useEffect(() => {
    obtenerGruposEItems();
  }, []);

  // console.log("GRUPOS E ITEMS", gruposEItems);

  //console.log("OBSERVACIONES: ", observaciones);

  const obtenerResultadosCheck = () => {
    fetch(
      UrlApi +
        "/checklist/verResultadoCheck/" +
        fechaFormat +
        "/" +
        localStorage.getItem("user") +
        "/" +
        fechaFormat +
        "/" +
        sucursal.id
    )
      .then((data) => data.json())
      .then((data) => {
        // --------------------- CHECKBOX------------------------------ //
        // Crear un nuevo objeto para almacenar los estados de los checkboxes actualizados
        const newCheckboxStates = { ...checkboxStates }; // Copiar el estado actual de los checkboxes
        // Iterar sobre los resultados obtenidos
        data.forEach((resultado) => {
          // Comprobar si el grupo ya existe en el estado de los checkboxes
          if (!newCheckboxStates[resultado.id_grupo]) {
            newCheckboxStates[resultado.id_grupo] = {};
          }
          // Actualizar el estado de los checkboxes para este grupo y item
          if (resultado.cumple === 1) {
            newCheckboxStates[resultado.id_grupo][resultado.id_item] = "cumple";
          } else if (resultado.no_cumple === 1) {
            newCheckboxStates[resultado.id_grupo][resultado.id_item] =
              "no_cumple";
          } else {
            newCheckboxStates[resultado.id_grupo][resultado.id_item] = "n_a";
          }
        });
        // Actualizar el estado checkboxStates con los nuevos valores obtenidos
        setCheckboxStates(newCheckboxStates);
        // También puedes hacer otras cosas con los resultados si es necesario
        setResultadosCheck(data);
        // -------------------- OBSERVACIONES ---------------------- //
        // Crear un nuevo objeto para almacenar las observaciones de cada ítem
        const newObservaciones = { ...observaciones };

        // console.log("NEW OBSERVACIONES: ", newObservaciones);
        // Iterar sobre los resultados obtenidos
        data.forEach((resultado) => {
          // Actualizar las observaciones para este ítem
          newObservaciones[resultado.id_item] = resultado.observacion || ""; // Asumiendo que la propiedad en los resultados es 'observacion'
        });
        // Actualizar el estado 'observaciones' con los nuevos valores obtenidos
        setObservaciones(newObservaciones);
        // También puedes hacer otras cosas con los resultados si es necesario
        setResultadosCheck(data);
        // -------------------- FECHA ---------------------- //
        // Extraer la fecha de los resultados si está presente en la respuesta de la API
        const fecha = data.length > 0 ? data[0].fecha : null;
        // Guardar la fecha en el estado
        setFechaResultadoCheck(fecha);
        // -------------------- UUID  ---------------------- //
        // Extraer el UUID si está presente en la respuesta de la API
        const uuid = data.length > 0 ? data[0].uuid : null;
        // Guardar el UUID en el estado
        setUuid(uuid);
        // -------------------- DIAS HABILES  ---------------------- //
        const diasHabiles = data.length > 0 ? data[0].dias_habiles : null;
        setDiasHabiles(diasHabiles);
      });
  };

  useEffect(() => {
    obtenerResultadosCheck();
  }, []);

  //console.log("OBTENER RESULTADOS CHECK DE VER", resultadosCheck);
  const [datosFlota, setDatosFlota] = useState();

  const obtenerResultadosFlota = () => {
    fetch(
      UrlApi +
        "/checklist_chofer_flota/verResultadoFlota/" +
        localStorage.getItem("user") +
        "/" +
        fechaFormat +
        "/" +
        sucursal.id
    )
      .then((data) => data.json())
      .then((data) => setDatosFlota(data));
  };
  useEffect(() => {
    obtenerResultadosFlota();
  }, []);

  //console.log("RESULTADOS FLOTA", datosFlota);
  const [deposito, setDeposito] = useState();

  const obtenerDepositos = () => {
    fetch(UrlApi + "/sucursales")
      .then((data) => data.json())
      .then((data) => setDeposito(data));
  };
  useEffect(() => {
    obtenerDepositos();
  }, []);

  // console.log("DEPOSITOS", depositoSeleccionado);
  const [comercial, setComercial] = useState();

  const obtenerComercial = () => {
    fetch(UrlApi + "/representantes/activos/")
      .then((data) => data.json())
      .then((data) => setComercial(data));
  };
  useEffect(() => {
    obtenerComercial();
  }, []);

  const [representante, setRepresentante] = useState();

  const obtenerRepresentante = () => {
    fetch(UrlApi + "/representantes/getid/" + localStorage.getItem("user"))
      .then((data) => data.json())
      .then((data) => setRepresentante(data));
  };
  useEffect(() => {
    obtenerRepresentante();
  }, []);

  // ------------------ESTILO -------------------- //
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const size = "small";
  //------------------- ADJUNTO ----------------------- //
  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
  };
  //-------- Función para contar la cantidad de checks marcados ------------- //
  const contarChecksMarcados = () => {
    let cantidadCumple = 0;
    let cantidadNoCumple = 0;
    let cantidadNA = 0;

    // Iterar sobre los grupos
    for (const grupoId in checkboxStates) {
      // Iterar sobre los items dentro del grupo
      for (const itemId in checkboxStates[grupoId]) {
        const estado = checkboxStates[grupoId][itemId];
        // Contar los estados de los checkboxes
        if (estado === "cumple") {
          cantidadCumple++;
        } else if (estado === "no_cumple") {
          cantidadNoCumple++;
        } else if (estado === "n_a") {
          cantidadNA++;
        }
      }
    }

    return {
      cumple: cantidadCumple,
      no_cumple: cantidadNoCumple,
      n_a: cantidadNA,
    };
  };
  // Llamada a la función para obtener la cantidad de checks marcados
  const cantidadChecks = contarChecksMarcados(checkboxStates);
  // console.log("Cantidad de checks 'Cumple':", cantidadChecks.cumple);
  // console.log("Cantidad de checks 'No cumple':", cantidadChecks.no_cumple);

  // -------- checkbox auditoria ------------ //
  // Agrega un nuevo estado para manejar el estado del checkbox de auditoría
  const [auditoriaCheckboxStates, setAuditoriaCheckboxStates] = useState({});

  //   console.log("RESPONSABLE",representante[0].nombre_apellido);

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const calcularTotalKgVendidos = () => {
    return (Array.isArray(datosFlota) ? datosFlota : []).reduce(
      (total, linea) => total + Number(linea.kg_vendidos || 0),
      0
    );
  };

  return (
    <div>
      <Box
        bgcolor="#2B76A6"
        padding={1}
        color="white"
        textAlign="center"
        display="flex" // Agregado para que los elementos se coloquen en línea
        alignItems="center"
        marginTop={1}
        flexWrap="wrap"
        gap={1}
      >
        <AssignmentIcon sx={{ fontSize: { xs: 28, md: 40 } }} />
        <Typography fontSize={{ xs: 24, sm: 22, md: 28 }}>
          Ver el control realizado
        </Typography>
      </Box>
      <br></br>
      {resultadosCheck && resultadosCheck.length > 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            width: "100%",
          }}
        >
          <Paper
            elevation={6}
            sx={{
              width: { xs: "90%", sm: "100%", md: "100%" }, //  más flexible
              maxWidth: "1100px", // límite en pantallas grandes
              mx: "auto", //  centrado
              p: { xs: 1, md: 4 },
              borderRadius: 2,
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "end",
                alignItems: "end",
                textAlign: "end",
              }}
            >
              <Grid item>
                <Button
                  variant="contained"
                  onClick={reactToPrintFn}
                  color="info"
                >
                  Imprimir
                </Button>
              </Grid>
            </Grid>

            <div ref={contentRef}>
              <Typography
                variant="h4"
                fontSize={{ xs: 21, md: 24 }}
                style={{
                  textDecoration: "underline",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: "start",
                  textAlign: "start",
                }}
              >
                <b>Control de depósito:</b>
              </Typography>
              <br></br>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography fontSize={{ xs: 15, md: 18 }} textAlign="left">
                    <b>Responsable:</b>&nbsp;{responsable} <br />
                    <b>Sucursal:</b>&nbsp; {sucursal.nombre} <br />
                    <b>Fecha:</b>&nbsp; {moment(fecha).format("MM-YYYY")}
                  </Typography>
                </Grid>
                {estados[0].auditado === 1 && (
                  <Grid item xs={12} md={6}>
                    <Typography fontSize={16} textAlign="left">
                      <b>Auditor:</b>&nbsp; {estados[0].auditor}
                      <br />
                      <b>Fecha de auditoría:</b>&nbsp;
                      {moment(estados[0].fecha_auditado).format("DD-MM-YYYY")}
                    </Typography>
                  </Grid>
                )}
              </Grid>

              <Table>
                <TableBody>
                  {/* Mapea sobre gruposEItems para renderizar cada grupo y sus items */}
                  {terminado === true &&
                    gruposEItems.map((grupoItem) => (
                      <TableRow key={grupoItem.grupo.id_grupo}>
                        <TableCell colSpan={6}>
                          {/* Título del Grupo */}
                          <Grid container>
                            <Grid item xs={12} sm={12}>
                              <Typography
                                className="titulo-grupo"
                                style={{
                                  fontSize: "16px",
                                  backgroundColor: "#C7C7C7",
                                  padding: 8,
                                  WebkitPrintColorAdjust: "exact", // MUESTRA COLOR AL IMPRIMIR para navegadores basados en WebKit
                                  printColorAdjust: "exact", // MUESTRA COLOR AL IMPRIMIR para otros navegadores que lo soporten
                                }}
                              >
                                <b>{grupoItem.grupo.nombre_grupo}</b>
                              </Typography>
                            </Grid>
                            {/* Items del Grupo */}
                            <Grid item xs={12} sm={12} mt={1}>
                              {grupoItem.items.map((item, index) => (
                                <Grid
                                  container
                                  key={item.id_item}
                                  spacing={2}
                                  alignItems="center"
                                >
                                  {/* Nombre y Definición del Item */}
                                  <Grid item xs={12} sm={4}>
                                    <b
                                      className="nombre-item"
                                      style={{ fontSize: "16px" }}
                                    >
                                      {item.nombre_item}
                                    </b>
                                    <br />
                                    <span
                                      className="definicion-item"
                                      style={{ fontSize: "16px" }}
                                    >
                                      {item.definicion_item}
                                    </span>
                                  </Grid>
                                  {/* Checkboxes */}
                                  <Grid item xs={2} sm={3}>
                                    <FormGroup aria-label="position">
                                      <Grid container direction="column">
                                        <Grid item>
                                          <FormControlLabel
                                            labelPlacement="end"
                                            label="Cumple"
                                            control={
                                              <Checkbox
                                                name="cumple"
                                                checked={
                                                  checkboxStates[
                                                    grupoItem.grupo.id_grupo
                                                  ]?.[item.id_item] ===
                                                    "cumple" || false
                                                }
                                              />
                                            }
                                          />
                                        </Grid>
                                        <Grid item>
                                          <FormControlLabel
                                            labelPlacement="end"
                                            label="No cumple"
                                            control={
                                              <Checkbox
                                                name="no_cumple"
                                                checked={
                                                  checkboxStates[
                                                    grupoItem.grupo.id_grupo
                                                  ]?.[item.id_item] ===
                                                    "no_cumple" || false
                                                }
                                              />
                                            }
                                          />
                                        </Grid>
                                        <Grid item>
                                          <FormControlLabel
                                            labelPlacement="end"
                                            label="N/A"
                                            control={
                                              <Checkbox
                                                name="n_a"
                                                checked={
                                                  checkboxStates[
                                                    grupoItem.grupo.id_grupo
                                                  ]?.[item.id_item] === "n_a" ||
                                                  false
                                                }
                                              />
                                            }
                                          />
                                        </Grid>
                                      </Grid>
                                    </FormGroup>
                                  </Grid>
                                  <Grid item xs={12} sm={5}>
                                    <TextField
                                      fullWidth
                                      size={size}
                                      margin="normal"
                                      style={{
                                        ...style,
                                        width: "100%",
                                      }}
                                      focused
                                      color="primary"
                                      name="observacion"
                                      label="Observaciones"
                                      variant="outlined"
                                      multiline
                                      rows={6}
                                      value={observaciones[item.id_item]} // Usar la observación correspondiente
                                      inputProps={{
                                        maxLength: 200,
                                        readOnly: true, // Establecer el campo como de solo lectura
                                      }}
                                      InputLabelProps={{
                                        style: {
                                          fontSize: "16px", // Ajusta el tamaño de fuente que necesites
                                        },
                                      }}
                                    />
                                  </Grid>
                                  {index !== grupoItem.items.length - 1 && ( // Asegura que el divider se renderice solo si el item NO es el último de los mapeados
                                    <Divider
                                      style={{
                                        width: "90%",
                                        marginTop: 8,
                                        marginBottom: 8,
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                      }}
                                    />
                                  )}
                                </Grid>
                              ))}
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <Divider
                style={{
                  width: "100%",
                  marginTop: 8,
                  marginBottom: 8,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />

              <div style={{ textAlign: "center", marginTop: 20 }}>
                <div>
                  <Typography
                    variant="poster"
                    fontSize={20}
                    style={{ textDecoration: "underline", marginTop: 20 }}
                  >
                    <b>Resultados: </b>
                  </Typography>
                  <br />
                  <br />
                  <Typography variant="poster" fontSize={19}>
                    Cumplidos : {cantidadChecks.cumple} - No cumplidos :{" "}
                    {cantidadChecks.no_cumple}
                  </Typography>
                  <Box mt={3}>
                    <Button
                      onClick={() => setOpenCloseAdj(!openCloseAdj)}
                      variant="outlined"
                      size="medium"
                      startIcon={<AttachFileIcon />}
                    >
                      VER ARCHIVOS ADJUNTOS
                    </Button>
                  </Box>
                </div>
              </div>

              <br></br>
              <Divider style={{ width: "100%", marginTop: 20 }} />
              <br></br>
              <div
                style={{
                  textAlign: "left",
                  textDecoration: "underline",
                }}
              >
                <Typography
                  fontSize={{ xs: 21, md: 24 }}
                  sx={{ textDecoration: "underline", mb: 2 }}
                >
                  <b>Flota de vehículos:</b>
                </Typography>
              </div>
              <Grid container spacing={2}>
                <Grid item xs={7} sm={3} mb={3}>
                  <TextField
                    label="Días habiles en el periodo"
                    size="small"
                    focused
                    fullWidth
                    inputProps={{
                      readOnly: true, // Establecer el campo como de solo lectura
                    }}
                    value={diasHabiles}
                  />
                </Grid>
              </Grid>
              <Box
                sx={{
                  padding: 2,
                  backgroundColor: "#f5f5f5",
                }}
              >
                {datosFlota &&
                  datosFlota.map((linea) => (
                    <Box
                      key={linea.id_flota}
                      sx={{
                        padding: { xs: 2, md: 3 },
                        marginBottom: 2,
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      }}
                    >
                      {/* sm para imprimir y lg pantalla */}
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={8} md={5} lg={5}>
                          <TextField
                            label="Dominio y Tipo"
                            size="small"
                            required
                            focused
                            fullWidth
                            inputProps={{
                              readOnly: true, // Establecer el campo como de solo lectura
                            }}
                            value={`${linea.patente} - ${linea.marca} - ${linea.modelo}`}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={1.5} lg={1.5}>
                          <TextField
                            label="Días Inactivos"
                            size="small"
                            required
                            focused
                            fullWidth
                            inputProps={{
                              readOnly: true, // Establecer el campo como de solo lectura
                            }}
                            value={linea.dias_inactivos} // Asegúrate de que esta propiedad exista en los datos
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={1.5} lg={1.5}>
                          <TextField
                            label="Kg.Vendidos"
                            size="small"
                            focused
                            required
                            fullWidth
                            inputProps={{
                              readOnly: true, // Establecer el campo como de solo lectura
                            }}
                            value={linea.kg_vendidos}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2} lg={2}>
                          <TextField
                            label="Km.Recorridos"
                            size="small"
                            focused
                            fullWidth
                            required
                            inputProps={{
                              readOnly: true, // Establecer el campo como de solo lectura
                            }}
                            value={linea.km_recorridos} // Asegúrate de que esta propiedad exista en los datos
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2} lg={2}>
                          <TextField
                            label="Lts.Combustible"
                            size="small"
                            focused
                            fullWidth
                            required
                            inputProps={{
                              readOnly: true, // Establecer el campo como de solo lectura
                            }}
                            value={linea.litros_combustible} // Asegúrate de que esta propiedad exista en los datos
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={5} lg={6}>
                          <TextField
                            label="Zona de Reparto"
                            size="small"
                            focused
                            fullWidth
                            required
                            inputProps={{
                              readOnly: true, // Establecer el campo como de solo lectura
                            }}
                            value={linea.zona}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={5} lg={6}>
                          <TextField
                            label="Chofer y Acompañante"
                            size="small"
                            focused
                            fullWidth
                            required
                            inputProps={{
                              readOnly: true, // Establecer el campo como de solo lectura
                            }}
                            value={linea.chofer_acompañante}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
              </Box>
              <Grid container justifyContent="center" alignItems="center">
                <Typography
                  fontWeight="bold"
                  sx={{ fontSize: { xs: 16, md: 19 } }}
                  mt={1}
                >
                  Total Kg. Vendidos: {calcularTotalKgVendidos()}
                </Typography>
              </Grid>
            </div>
            <br></br>
            <Grid
              container
              justifyContent="space-between"
              alignItems="flex-end"
              mt={1}
              mb={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver
              </Button>
            </Grid>
          </Paper>
        </div>
      ) : (
        <Paper
          elevation={6}
          sx={{
            mt: 2,
            mx: "auto",
            width: { xs: "80%", md: "90%" },
            p: 2,
          }}
        >
          <Typography variant="body1" color="textSecondary" align="center">
            <strong>
              {" "}
              No hay ningún resultado de control de depósito para la sucursal o
              fecha seleccionada.
            </strong>
          </Typography>
        </Paper>
      )}

      {openCloseAdj ? ( // ADJUNTAR IMAGEN
        <FileUploadCheck
          fileId={uuid}
          openclose={true}
          mostrar={false}
          onClose={() => handleOpenCloseAdj(false)} // Proporciona una función de cierre
        />
      ) : null}
      <br></br>
      <br></br>
    </div>
  );
}

export default VerResultadoCheck;
